import {
  Box,
  Grid,
  IconButton,
  Tab,
  Tabs,
  styled,
  useTheme,
} from "@mui/material";
import { Help, StockMarket } from "assets/Icon";
import React, { useMemo, useState } from "react";
import { convertTabValue, convertTabValueIndex } from "./components/constants";

import MobileTradeWrapper from "./components/MobileTradeWrapper";
import SwipeableViews from "react-swipeable-views";
import TradeHead from "./components/TradeHead";
import useIsMobileView from "hooks/useIsMobileView";
import { useNavigate } from "react-router-dom";

function BasicTradeFormWrapper({
  setShowMarketDrawer,
  coinMarketDetails,
  destinations,
  tradeInitial,
  walletTypeId,
  tradeAmountMax,
  getSingleMarketLoggedInList,
  handleChangeIndex,
  handleChange,
  setOpenModalHelp,
}) {
  const theme = useTheme();
  const navigate = useNavigate();

  const isMobileView = useIsMobileView();

  const [showTradingView, setShowTradingView] = useState(false);

  const handleShowOrHideTradingView = () => {
    setShowTradingView((v) => !v);
  };

  const handleChangeOpenModal = () => {
    setOpenModalHelp(true);
  };

  const activeTabIndex = useMemo(() => {
    if (tradeInitial?.lisWalletType) {
      const indexOfWallets = tradeInitial?.lisWalletType?.findIndex(
        (wallet) => wallet?.id === walletTypeId
      );

      if (indexOfWallets === -1) {
        return convertTabValueIndex;
      }
      return indexOfWallets;
    }
  }, [tradeInitial?.lisWalletType, walletTypeId]);

  return (
    <>
      <Grid container>
        {isMobileView && (
          <Grid item xs={12}>
            <TradeHead
              getSingleMarketLoggedInList={getSingleMarketLoggedInList}
              coinMarketDetails={coinMarketDetails}
              destinations={destinations}
              setShowMarketDrawer={setShowMarketDrawer}
            />
          </Grid>
        )}

        <Grid item xs={8}>
          <TabsStyle value={walletTypeId} onChange={handleChange}>
            {tradeInitial?.lisWalletType?.map((wallet) => (
              <Tab label={wallet?.name} value={wallet?.id} />
            ))}

            <ConvertTab
              onClick={() => navigate("/convert")}
              label="Convert"
              value={convertTabValue}
            />
          </TabsStyle>
        </Grid>

        <Grid item xs={4} textAlign="right">
          {isMobileView && (
            <IconButton color="text" onClick={handleShowOrHideTradingView}>
              <StockMarket color={theme.palette.text.main} />
            </IconButton>
          )}

          <IconButton color="text" onClick={handleChangeOpenModal}>
            <Help color={theme.palette.text.main} />
          </IconButton>
        </Grid>
      </Grid>

      <SwipeableViews
        axis={"x-reverse"}
        index={activeTabIndex}
        onChangeIndex={handleChangeIndex}
        disabled
      >
        {tradeInitial?.lisWalletType?.map((wallet) => (
          <Box value={walletTypeId} index={wallet?.id}>
            {walletTypeId === wallet?.id && (
              <MobileTradeWrapper
                handleShowOrHideTradingView={handleShowOrHideTradingView}
                showTradingView={showTradingView}
                coinMarketDetails={coinMarketDetails}
                setShowMarketDrawer={setShowMarketDrawer}
                tradeInitial={tradeInitial}
                tradeAmountMax={tradeAmountMax}
              />
            )}
          </Box>
        ))}
        <Box value={walletTypeId} index={3}>
          Convert
        </Box>
      </SwipeableViews>
    </>
  );
}

const ConvertTab = styled(Tab)(({ theme }) => ({
  [theme.breakpoints.up("md")]: {
    display: "none",
  },
}));

const TabsStyle = styled(Tabs)(({ theme }) => ({
  ".MuiButtonBase-root": {
    marginRight: theme.spacing(1),
  },
}));

export default BasicTradeFormWrapper;
